import { useEffect, useState } from 'react';

/**
 * Custom hook to get current time and update every second
 * @returns Current time formatted as HH:MM AM/PM
 */
export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return currentTime.toLocaleTimeString('en-US', {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
  });
};

export default useCurrentTime;
